import * as React from 'react';
import { SVGProps } from 'react';

const IconHandSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.2.8a.8.8 0 0 1 1.6 0V5h.7V2.25a.75.75 0 0 1 1.5 0v5.747C10 9.5 9 11 7 11c-2.5 0-4-2-5.614-4.48-.342-.524-.564-.908-.134-1.363C1.752 4.657 3 5.52 4 6.52V1.75a.75.75 0 1 1 1.5 0V5h.7V.8z" />
  </svg>
);
export default IconHandSizeXs;
